<template>
  <el-dialog
    :title="adGroupName ? `${adGroupName} - 配置Banner` : '配置Banner'"
    :visible.sync="dialogVisible"
    width="1200px"
    :before-close="handleClose"
    custom-class="ad-group-banner-dialog"
    append-to-body
  >
    <div class="dialog-content">
      <div v-if="showWarning" class="warning-tip">
        <i class="el-icon-warning-outline"></i>
        <span>启用后广告组将立即在乘客端展示,请关注banner状态</span>
      </div>

      <!-- 使用BannerList组件 -->
      <BannerList
        ref="bannerList"
        :hide-group-name-filter="true"
        :extra-query-params="extraQueryParams"
        :custom-table-config="customTableConfig"
        :showAddButton="true"
        :use-cache="false"
        v-if="dialogVisible"
      />
    </div>

    <div slot="footer" class="dialog-footer">
      <template v-if="dialogMode === 'config'">
        <el-button @click="handleCancel">返回广告组列表</el-button>
      </template>
      <template v-else>
        <el-button @click="handleCancel">暂不启用</el-button>
        <el-button type="primary" @click="handleConfirm">确认启用</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
  import BannerList from './BannerList.vue'

  export default {
    name: 'AdGroupBannerDialog',
    components: {
      BannerList
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      adGroupId: {
        type: [Number, String],
        default: ''
      },
      templateId: {
        type: [Number, String],
        default: ''
      },
      adGroupName: {
        type: String,
        default: ''
      },
      displayPageName: {
        type: String,
        default: ''
      },
      // 对话框模式: 'config' - 普通配置模式, 'enable' - 启用确认模式
      mode: {
        type: String,
        default: 'config'
      }
    },
    data() {
      return {
        dialogVisible: false,
        showWarning: true,
        extraQueryParams: {},
        customTableConfig: {
          showSelection: false
        },
        dialogMode: 'config'
      }
    },
    watch: {
      visible: {
        handler(val) {
          this.dialogVisible = val
          if (val && this.adGroupId) {
            this.extraQueryParams = {
              bannerGroupId: this.adGroupId,
              templateId: this.templateId,
              displayPageName: this.displayPageName
            }
            // 如果BannerList组件已经挂载，则调用其刷新方法
            if (this.$refs.bannerList) {
              this.$refs.bannerList.getList()
            }
          }
        },
        immediate: true
      },
      adGroupId: {
        handler(val) {
          if (val && this.dialogVisible) {
            this.extraQueryParams = {
              bannerGroupId: val,
              templateId: this.templateId,
              displayPageName: this.displayPageName
            }
            // 如果BannerList组件已经挂载，则调用其刷新方法
            if (this.$refs.bannerList) {
              this.$refs.bannerList.getList()
            }
          }
        },
        immediate: true
      },
      mode: {
        handler(val) {
          this.dialogMode = val
          // 在启用确认模式下才显示警告信息
          this.showWarning = val === 'enable'
        },
        immediate: true
      }
    },
    methods: {
      handleClose() {
        this.$emit('update:visible', false)
      },

      handleCancel() {
        this.$emit('update:visible', false)
      },

      handleConfirm() {
        // 处理选中的banner
        this.$emit('confirm')
      }
    }
  }
</script>

<style scoped>
  .warning-tip {
    background-color: #fff8f0;
    border: 1px solid #faecd8;
    padding: 10px 15px;
    border-radius: 4px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .warning-tip i {
    color: #e6a23c;
    font-size: 16px;
    margin-right: 8px;
  }

  .warning-tip span {
    color: #606266;
    font-size: 14px;
  }
</style>
